import {ProdutoCreateComponent} from '@components/produtos/pages/ProdutoCreateComponent.tsx';
import {useAlert} from '@contexts/hooks/useAlert.ts';
import {createSearchParams, useNavigate} from "react-router";
import {
    Button,
    ButtonGroup,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import React, {memo, useEffect, useState} from "react";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {IProdutoFilters} from "@models/produtos/IProdutoFilters.tsx";
import {IProduto} from "@models/produtos/produto.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {GetProdutos} from "@components/produtos/endpoints/__produto_endpoints.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {ProdutoInformacaoRow} from "@components/produtos/ProdutoInformacao.tsx";
import {AddOutlined, OpenInNew, Publish} from "@mui/icons-material";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {fullHeight} from "@models/helpers.ts";
import {ImportProdutoComponent} from "@components/produtos/ImportProdutoComponent.tsx";
import {SearchTextField} from "@components/shared/textField/SearchTextField.tsx";

export interface ProdutosConsultaPageProps extends DefaultPageProps {
    filtros?: Partial<IProdutoFilters>;
    onSelect?: (produto: IProduto) => void;
}


const TBody = memo(({produtos}: { produtos: IProduto[] }) => {
	const navigate = useNavigate();
	return (<TableBody>
		{produtos.map((produto, index) => (
			<ProdutoInformacaoRow
				key={index}
				value={produto}
				EndComponent={(p) => <IconButton size={'small'}
				                                 onClick={() => {
					                                 navigate({
						                                 pathname: '/produtos/detalhes',
						                                 search: createSearchParams({
							                                 produtoId: p.id.toString(),
						                                 }).toString(),
					                                 }, {replace: true});

				                                 }}
				>
					<OpenInNew/>
				</IconButton>}/>
		))}
	</TableBody>)
}, (prev, next) => prev.produtos.length == next.produtos.length)

export const ProdutosPage: React.FC<ProdutosConsultaPageProps> = (props) => {
    const {Get} = useApi();
    const {addPopUp} = useAlert()
    const {pageProps} = props
    const [filters, setFilters] = useState<IProdutoFilters>(props.filtros ?? {});
    const [produtos, setProdutos] = useState<IProduto[]>([]);
    const [pagination, setPagination] = useState<IPagination>(props.pageProps?.pagination ?? {page: 1, pageSize: 10});

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination({...pagination, page: 1});
            return;
        }

        setPagination(prev => ({...prev, loading: true}))
        Get(GetProdutos(filters, pagination)).then(x => {
            if (x.hasData) {
                setProdutos(x.items);
                setPagination(prev =>
                    ({...prev, ...x.pagination})
                );
            }
        }).finally(() => {
            setPagination(prev => ({...prev, ignoreCache: false, loading: false}))
        });

    }, [pagination.page, pagination.ignoreCache == true]);

    useEffect(() => {
        if (pageProps) {
            pageProps.setPagination(({...pageProps.pagination, ...pagination}))
        }
    }, [pagination]);

    useEffect(() => {
        if (pageProps) {
            setPagination(prev => ({...prev, ...pageProps.pagination}))
        }
    }, [pageProps]);



    return (
        <DefaultContainer titulo={props.hideHeader ? '' : "Consulta de produtos"} size={"large"}
                          pageProps={{pagination, setPagination}}
                          UpperComponent={
                              <Grid container>
                                  <Grid container size={12} spacing={1}>
                                      <Grid size={{xs: 12, md: 6}}>
                                          <SearchTextField onSearch={() => {
                                              setPagination({...pagination, page: 0})
                                          }} pageProps={{pagination, setPagination}}
                                                           value={filters.nome}
                                                           onChange={(e) => {
                                                               setFilters({
                                                                   ...filters,
                                                                   nome: e.target.value,
                                                               });
                                                           }}
                                                           label={'Nome'}
                                          />
                                      </Grid>
                                      <Grid size={{xs: 12, md: 6}}>
                                          <ButtonGroup sx={{...fullHeight}} fullWidth>
                                              <Button variant={'outlined'} endIcon={<AddOutlined/>} onClick={() => {
                                                  addPopUp({
                                                      title: 'Criar novo produto',
                                                      content: <ProdutoCreateComponent/>
                                                  })
                                              }}
                                              >Criar novo</Button>
                                              <Button variant={'outlined'} endIcon={<Publish/>} onClick={() => {
                                                  addPopUp({
                                                      title: 'Importar novos produto',
                                                      content: <ImportProdutoComponent onCreate={() => {
                                                      }}/>
                                                  })
                                              }}
                                              >Importar</Button>
                                          </ButtonGroup>
                                      </Grid>
                                  </Grid>
                              </Grid>}>
            <TableContainer>
                <Table size={'small'} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Id Erp</TableCell>
                            <TableCell>Id Familia</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell align={'right'}>Mais</TableCell>
                        </TableRow>
                    </TableHead>
                    <TBody produtos={produtos}/>
                </Table>
            </TableContainer>
        </DefaultContainer>
    );
};